import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import getRandomId from 'commons/getRandomId';
import RunHook from './RunHook';

// eslint-disable-next-line import/no-mutable-exports
let getHookResult = () => {};

// To support rendering of hooks outside of React components, this component
// needs to be rendered just once within the component tree.
const HookRunner = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [hooksToRun, setHooksToRun] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = hookToRun => {
      setHooksToRun(currentHooksToRun => [...currentHooksToRun, hookToRun]);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const addHook = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = id => {
      setHooksToRun(currentHooksToRun_0 => currentHooksToRun_0.filter(hook => hook.id !== id));
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const removeHook = t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      getHookResult = t5 => {
        const {
          hookArguments,
          isResultReady,
          hook: hook_0
        } = t5;
        return new Promise((resolve, reject) => {
          const id_0 = getRandomId();
          addHook({
            hookArguments,
            id: id_0,
            isResultReady,
            hook: hook_0,
            resolve: async result => {
              const clonedResult = result ? JSON.parse(JSON.stringify(result)) : undefined;
              removeHook(id_0);
              resolve(clonedResult);
            },
            reject: async error => {
              const clonedError = error ? JSON.parse(JSON.stringify(error)) : undefined;
              removeHook(id_0);
              reject(clonedError);
            }
          });
        });
      };
    };
    t4 = [];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== hooksToRun) {
    t5 = hooksToRun.map(_temp);
    $[5] = hooksToRun;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <>{t5}</>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export { getHookResult };
export default HookRunner;
function _temp(t0) {
  const {
    hook: hook_1,
    hookArguments: hookArguments_0,
    id: id_1,
    isResultReady: isResultReady_0,
    reject: reject_0,
    resolve: resolve_0
  } = t0;
  return <RunHook hook={hook_1} hookArguments={hookArguments_0} isResultReady={isResultReady_0} key={id_1} reject={reject_0} resolve={resolve_0} />;
}